enum SendDescriptionToPos {
  Never = 0,
  Always = 1,
  BarcodeScan = 2,
}

export { SendDescriptionToPos };
